import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllCodeListMainResponseModel } from '@gtpl/shared-models/planning';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { CodeListMainService } from './code-list-main.service';
import { CodeListMainIdRequest } from './dto/code-list-main-id.request';
import { CodeListMainId } from './dto/code-list-main-req';
import { CodeListMainDTO } from './dto/code-list-main.dto';
import { CodeLisSOItemReq } from './dto/code-list-so-item-req';
import { CodeListValidationReq } from './dto/code-list-validation-request';
import { SubJobCodeListRequest } from './dto/sub-job-code-list-req';
import { SubJobReviseReq } from './dto/sub-job-revise-req';
import { SubJobRevisionCodesRequest } from './dto/sub-job-revision-codes-req';

@Controller('code-list-main')
@ApiTags('code-list-main')
export class CodeListMainController {

    constructor(
        private codeListMainService:CodeListMainService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createCodeListInfo')
    async createLabellingInfo(@Body() info: CodeListMainDTO,isUpdate:boolean): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.createCodeListInfo(info,info.isUpdate);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllCodeLists')
    async getAllCodeLists(@Body() req : UnitRequest): Promise<AllCodeListMainResponseModel> {
        try {
            return await this.codeListMainService.getAllCodeLists(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllCodeListMainResponseModel, error);
        }
    }


    @Post('/getCodeListsForId')
    async getCodeListsForId(@Body() qReq : CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.getCodeListsForId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/geTracebilityCodeForSoId')
    async geTracebilityCodeForSoId(@Body() qReq : CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.geTracebilityCodeForSoId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    @Post('/validateCodeListCartons')
    async validateCodeListCartons(@Body() qReq : CodeListValidationReq): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.validateCodeListCartons(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCodeListPrintData')
    async getCodeListPrintData(@Body() qReq : CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.getCodeListPrintData(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getCodeListDataForUpdate')
    async getCodeListDataForUpdate(@Body() req : CodeListMainId): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.getCodeListDataForUpdate(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/geTracebilityCodeForSoItem')
    async geTracebilityCodeForSoItem(@Body() req : CodeLisSOItemReq): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.geTracebilityCodeForSoItem(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateCodeListForSubJob')
    async updateCodeListForSubJob(@Body() req : SubJobCodeListRequest[]): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.updateCodeListForSubJob(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateCodeListFromSubJobRevision')
    async updateCodeListFromSubJobRevision(@Body() req : SubJobReviseReq): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.updateCodeListFromSubJobRevision(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getUnitsForCodeList')
    async getUnitsForCodeList(): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.getUnitsForCodeList();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCodeListPrimaryPrintData')
    async getCodeListPrimaryPrintData(@Body() qReq : CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            return await this.codeListMainService.getCodeListPrimaryPrintData(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    
}
